const testData = {
  reportGroups: [
    {
      report_id: "group1",
      report_name: "顧客用"
    },
    {
      report_id: "group2",
      report_name: "交通用"
    },
    {
      report_id: "group3",
      report_name: "債務用"
    },
  ],
  reportLabels: {
    group1: [
      { id: '1', label: '契約書' },
      { id: '2', label: '申請書' },
      { id: '3', label: '訴訟' },
      { id: '4', label: 'ほげほげ' },
      { id: '5', label: 'ラベル5' },
      { id: '6', label: 'ラベル6' },
      { id: '7', label: 'ラベル7' },
      { id: '8', label: 'ラベル8' },
      { id: '9', label: 'ラベル9' },
      { id: '10', label: 'ラベル10' },
    ],
    group2: [
      { id: '1', label: 'グループラベル２' },
      { id: '2', label: '２' },
      { id: '3', label: '３' },
      { id: '4', label: '４' },
      { id: '5', label: '' },
      { id: '6', label: '' },
      { id: '7', label: '' },
      { id: '8', label: '' },
      { id: '9', label: '' },
      { id: '10', label: '' },
    ],
    group3: [
      { id: '1', label: 'グループラベル３' },
      { id: '2', label: '重要' },
      { id: '3', label: '' },
      { id: '4', label: 'ほげほげ' },
      { id: '5', label: '' },
      { id: '6', label: '' },
      { id: '7', label: '' },
      { id: '8', label: '' },
      { id: '9', label: '' },
      { id: '10', label: '' },
    ],
  },
  reports: {
    group1: [{
      create_date: "2019-04-13 12:58:16.290729",
      file: "07734ba3-f3f8-43b2-93c0-2e9521c51933/54904008-606f-486d-b10d-278b4bedc6b8_template_4.docx",
      group: "グループ",
      id: "cba116e6-db25-4ed6-9479-de45723ddd11",
      kind: "word",
      name: "休暇申請書２",
      org_file: "template_4.docx",
      size: 20917,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      update_date: "2019-04-13 13:36:28.219296",
    },
    {
      create_date: "2019-04-13 12:58:16.290729",
      file: "07734ba3-f3f8-43b2-93c0-2e9521c51933/54904008-606f-486d-b10d-278b4bedc6b8_template_4.docx",
      group: "グループ",
      id: "cba116e6-db25-4ed6-9479-de45723ddd12",
      kind: "word",
      name: "休暇申請書２",
      org_file: "template_4.docx",
      size: 20917,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      update_date: "2019-04-13 13:36:28.219296",
    },
    {
      create_date: "2019-04-13 12:58:16.290729",
      file: "07734ba3-f3f8-43b2-93c0-2e9521c51933/54904008-606f-486d-b10d-278b4bedc6b8_template_4.docx",
      group: "グループ",
      id: "cba116e6-db25-4ed6-9479-de45723ddd13",
      kind: "word",
      name: "休暇申請書２",
      org_file: "template_4.docx",
      size: 20917,
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      update_date: "2019-04-13 13:36:28.219296",
    }
    ],
  },
  information: [
    { lastUpdate: '05月01日', content: 'サービス名称を変更しました(googleにジャンプ)', url: "https://google.com" },
    { lastUpdate: '12月30日', content: 'サービス名称を変更しました', url: "xxx"  },
    { lastUpdate: '01月18日', content: 'xxxxxxxxxxxxxx', url: "xxx"  },
    { lastUpdate: '10月28日', content: 'xxxxxを開始しました！', url: "xxx"  },
    { lastUpdate: '05月01日', content: 'サービス名称を変更しました(googleにジャンプ)', url: "https://google.com" },
    { lastUpdate: '12月30日', content: 'サービス名称を変更しました', url: "xxx"  },
    { lastUpdate: '01月18日', content: 'xxxxxxxxxxxxxx', url: "xxx"  },
    { lastUpdate: '10月28日', content: 'xxxxxを開始しました！', url: "xxx"  },
    { lastUpdate: '05月01日', content: 'サービス名称を変更しました(googleにジャンプ)', url: "https://google.com" },
    { lastUpdate: '12月30日', content: 'サービス名称を変更しました', url: "xxx"  },
    { lastUpdate: '01月18日', content: 'xxxxxxxxxxxxxx', url: "xxx"  },
    { lastUpdate: '10月28日', content: 'xxxxxを開始しました！', url: "xxx"  },
    { lastUpdate: '05月01日', content: 'サービス名称を変更しました(googleにジャンプ)', url: "https://google.com" },
    { lastUpdate: '12月30日', content: 'サービス名称を変更しました', url: "xxx"  },
    { lastUpdate: '01月18日', content: 'xxxxxxxxxxxxxx', url: "xxx"  },
    { lastUpdate: '10月28日', content: 'xxxxxを開始しました！', url: "xxx"  },
  ],
  usageHistory: [
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 1, displayName: 'xxxx契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-10-15 13:43:27', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 2, displayName: 'yyyyyyyyy契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-15 06:00:53', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 3, displayName: '12345申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-26 06:26:28', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 4, displayName: 'zzzzz契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-10 10:28:46', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 5, displayName: '67890申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-06 14:38:38', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 11, displayName: 'xxxx契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-10-15 13:43:27', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 12, displayName: 'yyyyyyyyy契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-15 06:00:53', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 13, displayName: '12345申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-26 06:26:28', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 14, displayName: 'zzzzz契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-10 10:28:46', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 15, displayName: '67890申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-06 14:38:38', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 21, displayName: 'xxxx契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-10-15 13:43:27', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 22, displayName: 'yyyyyyyyy契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-15 06:00:53', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 23, displayName: '12345申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-26 06:26:28', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 24, displayName: 'zzzzz契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-10 10:28:46', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 25, displayName: '67890申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-06 14:38:38', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 31, displayName: 'xxxx契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-10-15 13:43:27', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 32, displayName: 'yyyyyyyyy契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-12-15 06:00:53', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 33, displayName: '12345申込書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-26 06:26:28', result: '成功' },
    { reportId: "reportidxxx", reportName: "レポート名", group: "グループ名", processTime: 34, displayName: 'zzzzz契約書', fileName: 'xxxxxxxxxxx.docx', operatedAt: '2016-04-10 10:28:46', result: '成功' },
  ],
  usageHistoryOfAmount: {
    labels: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月'],
    datasets: [
      {
        type: "line",
        fill: 0,
        label: "使用料金(円)",
        data: [1000, 1000, 1000, 1000, 2000, 1000, 1000, 1000, 1000, 1000, 1000, 2000],
        yAxisID: "right-axis",
        backgroundColor: "rgb(229, 67, 99)",
        borderColor: "rgb(229, 67, 99, 0.8)",
        lineTension: 0,
      },
      {
        type: "bar",
        label: "使用量(回)",
        data: [40, 20, 30, 50, 90, 10, 20, 40, 50, 70, 90, 100],
        yAxisID: "left-axis",
        backgroundColor: "rgb(26, 188, 156, 0.1)",
        borderColor: "rgb(26, 188, 156)",
        borderWidth: 1,
      },
    ],
  },
  contractInfo: [{
    label: "ご契約中のプラン",
    text: "スタンダートプラン(月額)"
  }, {
    label: "基本",
    text: "¥1,000円(〜500帳票作成含む)"
  }, {
    label: "500帳票以降",
    text: "¥2円/帳票"
  }],
  invoices: {
    2018: [
      {
        id: "1",
        due_date: "1ヶ月",
        nickname: "プラン名",
        period_start: "2018/01/01",
        period_end: "2018/01/31",
        number: "C6DDA1D-0001",
        amount_due: 2000,
        created: "2019/02/03",
        status: "支払い済み",
        hosted_invoice_url: "http://fefefefeffe.com",
        invoice_pdf: "http://fefefefefefe.com"
      },
      {
        id: "2",
        due_date: "1ヶ月",
        nickname: "プラン名",
        period_start: "2018/01/01",
        period_end: "2018/01/31",
        number: "C6DDA1D-0001",
        amount_due: 2000,
        created: "2019/02/03",
        status: "支払い済み",
        hosted_invoice_url: "http://fefefefeffe.com",
        invoice_pdf: "http://fefefefefefe.com"
      },
      {
        id: "3",
        due_date: "1ヶ月",
        nickname: "プラン名",
        period_start: "2018/01/01",
        period_end: "2018/01/31",
        number: "C6DDA1D-0001",
        amount_due: 2000,
        created: "2019/02/03",
        status: "支払い済み",
        hosted_invoice_url: "http://fefefefeffe.com",
        invoice_pdf: "http://fefefefefefe.com"
      },
      {
        id: "4",
        due_date: "1ヶ月",
        nickname: "プラン名",
        period_start: "2018/01/01",
        period_end: "2018/01/31",
        number: "C6DDA1D-0001",
        amount_due: 2000,
        created: "2019/02/03",
        status: "支払い済み",
        hosted_invoice_url: "http://fefefefeffe.com",
        invoice_pdf: "http://fefefefefefe.com"
      }
    ]
  },
  // for storybook 
  mockStore: {
    auth: {
      namespaced: true,
      state: {
        loginUserInfo: {
          username: "テストユーザ",
          attributes: {
            email: "test@example.com",
            name: "テストユーザ123"
          }
        },
      }, 
    },
    report: {
      namespaced: true,
      state: {
        reports: [],
        reportGroups: [],
        reportLabels: [],
      },
      mutations: {
        getReports: (state, groups) => {
          state.reportGroups = groups;
        },
        getTemplates: (state, templates) => {
          state.reports = templates;
        },
        getTemplateGroups: (state, groups) => {
          state.reportLabels = groups;
        },
      },
      actions: {
        getReports: ({commit}) => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              commit('getReports', testData.reportGroups);
              resolve();
            }, 0);
          });
        },
        getTemplates: ({commit}) => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              commit('getTemplates', testData.reports.group1);
              commit('getTemplateGroups', ["グループ"]);
              resolve();
            }, 0);
          });
        },
      }
    }
  },
  mockRouter: {
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
      path: '/first',
      name: 'FIRST',
      children: [
        {
          path: '/second',
          name: 'SECOND',
          children: [
            {
              path: '/third',
              name: 'THIRD',
            },
          ],
        },
      ]},
    ],
  },
}

export default testData;